
  // Cerrar menú con tecla Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
      document.body.classList.remove('nav-open');
    }
  });

  // Lluvia de pétalos al entrar (solo primera carga)
  (function () {
    const container = document.querySelector('.petal-rain');
    if (!container) return;

    // Path del isotipo
    const isoPath = 'M433.27,251.84c40.02-2.33,30.71,63.65-6.84,53.47-7.98.43-12.18,12.58-20.03,10.88,12.16-10.24,2.4-21.99-3.41-31.9-3.07.65-8.55-4.36-5.62-6.82.24-14.57,19.35-33.41,35.91-25.62h0ZM421.82,292.48c-1.03,4.48-2.75,8.61-5.77,12.27l.2.11c6.05-4.79,11.26-12.1,13.68-18.98,2.98-5.83-.14-16.18-6.52-11.51-4.88,3.58.2,10.28-1.6,18.11h.01Z';

    const NUM_PETALS = 14;
    const w = window.innerWidth;

    for (let i = 0; i < NUM_PETALS; i++) {
      const petal = document.createElement('div');
      petal.className = 'petal-rain__item';

      // Aleatorios
      const size = 10 + Math.random() * 38;          // 10-48px (más rango)
      const startX = Math.random() * w;
      const drift = (Math.random() - 0.5) * 200;
      const rotStart = Math.random() * 360;
      const rotEnd = rotStart + (Math.random() - 0.5) * 720;
      const duration = 1.8 + Math.random() * 1.8;    // 1.8-3.6s (más rápido)
      const delay = Math.random() * 1.2;             // hasta 1.2s
      const opacity = 0.55 + Math.random() * 0.45;

      petal.style.cssText = `
        left: ${startX}px;
        top: -50px;
        width: ${size}px;
        --drift: ${drift}px;
        --rot-start: ${rotStart}deg;
        --rot-end: ${rotEnd}deg;
        animation-duration: ${duration}s;
        animation-delay: ${delay}s;
        opacity: ${opacity};
      `;

      petal.innerHTML = `<svg viewBox="391.4 241.1 75.5 79.8"><path fill="currentColor" d="${isoPath}"/></svg>`;
      container.appendChild(petal);
    }

    // Limpiar tras la animación
    setTimeout(() => {
      container.remove();
    }, 6000);
  })();
